/*
 * Selects a variant through the native variant picker (so the whole page swaps without a reload).
 * Used by the "Découvrir un autre millésime" CTA (snippets/lpb-other-millesime.liquid) and the
 * vintage cards (sections/main-product-wine-millesime.liquid).
 */
(function () {
  if (window.lpbSelectVariantOptions) return;

  // options: the variant's option values, in order (e.g. ["2024", "750 mL"]).
  window.lpbSelectVariantOptions = function (options) {
    var picker = document.querySelector('variant-selects');
    if (!picker || !options || !options.length) return false;
    var changed;
    options.forEach(function (value) {
      picker.querySelectorAll('select').forEach(function (select) {
        var option = Array.from(select.options).find(function (item) { return item.value === value; });
        if (option) { select.value = value; option.selected = true; changed = select; }
      });
      picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
        if (input.value === value) { input.checked = true; changed = input; }
      });
    });
    if (!changed) return false;
    changed.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lpb-other-millesime]');
    if (!button) return;
    event.preventDefault();
    var options = [];
    try { options = JSON.parse(button.dataset.options || '[]'); } catch (e) { return; }
    window.lpbSelectVariantOptions(options);
  });
})();
